
  import React from "react"
  import Component from "/repo/website/src/layouts/index.js"
  import data from "/repo/website/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js